import TrainingSVG from '../../assets/svg/training.svg';
export default TrainingSVG;
